export const tableHeader = [
  'Institue Name',
  'Branch Name',
  'Batch Name',
  'Course Name',
  'Batch Start Date',
  'Batch End Date',
  'Start Timing',
  'End Timing',
  'Batch Size',
  'Description',
  'Action'
]
